import * as React from 'react';
import { State } from './client-reducer';

export interface ChatIconProps extends State {
    onClick(): void;
}

export default function ChatIcon({ connected, settings, onClick }: ChatIconProps) {
    if (!connected) {
        return null;
    }

    const { backgroundColor, textColor, minimizedPluginText } = settings;

    return (
        <span className="chatIcon" onClick={onClick} style={{ color: textColor, background: backgroundColor }}>
            {replaceEscapeChars(minimizedPluginText)}
        </span>
    );
}

function replaceEscapeChars(content: string) {
    return content
        .split(/(\n)/)
        // eslint-disable-next-line react/no-array-index-key
        .map((chunk, i) => (/\n/.test(chunk) ? <br key={i}/> : chunk));
}
